import {Platform} from "@variocube/app-api";
import {EventSupportingApp, occupyAndConfirm} from "@variocube/app-common";
import {AppContext, AppErrorBoundary, ThemeProvider} from "@variocube/cube-ui";
import * as React from "react";
import {render} from "react-dom";
import icon from "./service-icon.svg";
import {OccupancyType} from "./types";
import {App} from "./app";
import {LocalizationProvider, SUPPORTED_LANGUAGES} from "../i18n";


export default class extends EventSupportingApp {

    constructor(p: Platform) {
        super(p, icon, "hsl(167,66%,31%)", SUPPORTED_LANGUAGES);
    }

    render(root: Element) {
        const appContext = {
            platform: this.platform,
            appEventSupport: this.eventSupport
        };
        const defaultTheme = {
            colorBackground: "#fff",
            colorForeground: "hsl(167,10%,20%)",
            colorPrimary: "hsl(167,66%,31%)",
            colorSeparator: "hsl(167,20%,30%)",
            colorInputBackground: "#fff",
        };
        render((
            <AppContext.Provider value={appContext}>
                <ThemeProvider defaultTheme={defaultTheme}>
                    <AppErrorBoundary appId={this.platform.appId} cubeId={this.platform.hostname}>
                        <LocalizationProvider app={this}>
                            <App/>
                        </LocalizationProvider>
                    </AppErrorBoundary>
                </ThemeProvider>
            </AppContext.Provider>
        ), root);
    }

    async loadMockData() {

        const recipients = [
            {
                customerName: "Peter Karrer",
                customerEmails: ["peter.karrer@variocube.com"],
                customerPhones: ["+43 650 7788311"]
            },
            {
                customerName: "Matthias Steinbauer",
                customerEmails: ["matthias.steinbuaer@variocube.com"],
                customerPhones: ["+43 664 75003498"]
            },
            {
                customerName: "Sudeep Nethra",
                customerEmails: ["matthias.steinbuaer@variocube.com"],
                customerPhones: ["+43 664 75003498"]
            }
        ];

        const awaitingPickup1 = await occupyAndConfirm(this.platform, {
            accessCode: "11111",
            type: "M",
            content: {
                customerName: recipients[0].customerName,
                customerEmails: recipients[0].customerEmails,
                customerPhones: recipients[0].customerPhones,
                description: "Gold",
                storageCode: "11111",
                pickupCode: "21111",
                replacement: false,
                type: OccupancyType.Outbound
            },
        });
        awaitingPickup1.content.reservationUuid = awaitingPickup1.uuid;
        awaitingPickup1.content.occupiedFrom = awaitingPickup1.created;

        const awaitingPickup2 = await occupyAndConfirm(this.platform, {
            accessCode: "11112",
            type: "M",
            content: {
                customerName: recipients[1].customerName,
                customerEmails: recipients[1].customerEmails,
                customerPhones: recipients[1].customerPhones,
                description: "Gold",
                storageCode: "11112",
                pickupCode: "21112",
                replacement: false,
                type: OccupancyType.Outbound
            },
        });
        awaitingPickup2.content.reservationUuid = awaitingPickup2.uuid;
        awaitingPickup2.content.occupiedFrom = awaitingPickup2.created;

        const awaitingPickup3 = await occupyAndConfirm(this.platform, {
            accessCode: "11112",
            type: "M",
            content: {
                customerName: recipients[2].customerName,
                customerEmails: recipients[2].customerEmails,
                customerPhones: recipients[2].customerPhones,
                description: "MacBook Pro M1 2021",
                storageCode: "11113",
                pickupCode: "21113",
                replacement: true,
                replacementDescription: "Defektes MacBook 2015 (Wasserschaden)",
                type: OccupancyType.Outbound
            },
        });
        awaitingPickup3.content.reservationUuid = awaitingPickup3.uuid;
        awaitingPickup3.content.occupiedFrom = awaitingPickup3.created;

        const awaitingStorage1 = {
            customerName: recipients[2].customerName,
            customerEmails: recipients[2].customerEmails,
            customerPhones: recipients[2].customerPhones,
            description: "Gold für Sudeep",
            storageCode: "91111",
            pickupCode: "91111",
            replacement: false,
            type: OccupancyType.Outbound
        };

        const cases = [];
        cases[awaitingPickup1.content.storageCode] = awaitingPickup1.content;
        cases[awaitingPickup2.content.storageCode] = awaitingPickup2.content;
        cases[awaitingPickup3.content.storageCode] = awaitingPickup3.content;
        cases[awaitingStorage1.storageCode as any] = awaitingStorage1;
        return {
            cases: cases
        };
    }
}
